import type { PortalModule } from '../modules/types';

const STATUS_LABEL: Record<PortalModule['status'], string> = {
  active: '进行中',
  planned: '筹备中',
  archived: '已归档',
};

export default function ProjectArea({ module }: { module: PortalModule }) {
  return (
    <>
      <div className="page-head">
        <div>
          <div className="eyebrow">Project Area</div>
          <h1>{module.title}</h1>
        </div>
        <span className="badge accent">{STATUS_LABEL[module.status]}</span>
      </div>

      <section className="side-card">
        <h3>区域筹备中</h3>
        <p className="caption">{module.summary}</p>
        <div className="kv">
          <span>所属</span>
          <b>{module.owner}</b>
        </div>
        <div className="kv">
          <span>状态</span>
          <b>{STATUS_LABEL[module.status]}</b>
        </div>
        {module.progress ? (
          <>
            <div className="kv">
              <span>当前阶段</span>
              <b>{module.progress.phase}</b>
            </div>
            <div className="kv">
              <span>进度</span>
              <b>{module.progress.percent}%</b>
            </div>
            <div className="kv">
              <span>更新于</span>
              <b>{module.progress.updatedAt}</b>
            </div>
          </>
        ) : null}
      </section>
    </>
  );
}